import solutionTableFatherDlg from './src/main.js'
export default solutionTableFatherDlg



// WEBPACK FOOTER //
// ./src/components/solutionTableFatherDlg/index.js